import React from 'react';

const heroSquares = [
  { x: '10%', y: '15%', d: '5s', s: '40px' },
  { x: '80%', y: '20%', d: '7s', s: '36px' },
  { x: '30%', y: '60%', d: '6.5s', s: '28px' },
  { x: '55%', y: '40%', d: '8s', s: '48px' },
  { x: '70%', y: '72%', d: '5.5s', s: '32px' },
];

const EpicHero = () => {
  return (
    <section className="hero hero--epic">
      <div className="hero__bg parallax-bg" data-speed="0.2">
        <div
          className="hero__image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1529156069898-49953eb1b5ae?q=80&w=2670&auto=format&fit=crop')",
          }}
        ></div>
        <div className="hero__overlay"></div>
      </div>
      <div className="hero__decor">
        {heroSquares.map((sq, i) => (
          <span
            className="hero__square"
            key={i}
            style={{ '--x': sq.x, '--y': sq.y, '--d': sq.d, '--s': sq.s }}
          ></span>
        ))}
      </div>
      <div
        className="container hero__content-epic parallax-element"
        data-speed-y="-0.4"
      >
        <h1 className="hero__title-epic">
          <span className="line"><span className="word">LA NOSTRA</span></span>
          <span className="line"><span className="word">GENERAZIONE</span></span>
          <span className="line"><span className="word accent">CAMBIA</span></span>
          <span className="line"><span className="word">L'ITALIA.</span></span>
        </h1>
      </div>
      <div className="hero__scroll-indicator" aria-hidden="true">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default EpicHero;
